import { authHeader, ApiConfigs } from '../_helpers'

export const ImprimanteService = {
  index,
  store,
  getById 
}

async function index() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };

  return await fetch(
    `${ApiConfigs.base_url}${ApiConfigs.imprimante.index}`,
    requestOptions
  ).then(handleResponse);
}

async function getById(id) { 
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };

  return await fetch(
    `${ApiConfigs.base_url}${ApiConfigs.imprimante.getById.replace('{id}', id)}`,
    requestOptions
  ).then(handleResponse);
}
async function store(imprimanteData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(imprimanteData),
  };

  return await fetch(
    `${ApiConfigs.base_url}${ApiConfigs.imprimante.store}`,
    requestOptions
  ).then(handleResponse);
}


async function handleResponse(response) {
  return response.text().then(text => {
    text = text.slice(text.indexOf('{'), text.lastIndexOf('}') + 1);
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("profile"); 
        localStorage.removeItem("token"); 
        window.location.href = '/login'
      }
      if (response.status === 404) {
        return null
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}
